import React, { useState, useEffect } from "react";
import { Button, Empty, Select } from "antd";

import HolidaysConfigTable from "../HolidaysConfigTable";

import "./holidays.scss";
import useMyTimeSheetStore from "../../store/mytimesheet";

const holidayTitles = [
  "S. No.",
  "Holiday Name",
  "Location",
  "Date",
];

function Holidays() {
    const {getMyLeavesConfigList,myLeaveConfigList} = useMyTimeSheetStore()
    const [selecteID, setID] = useState(0);// all

    useEffect(() => {
        getMyLeavesConfigList()
    }, []);

    useEffect(() => {
        if(myLeaveConfigList !=null){
            const today = new Date();
            const year = today.getFullYear();
            for( var i=0; i < holidayData?.length ; i++){
                if(holidayData[i].year == year){
                setID(i) 
                break; 
                }
            }   
        }       
    }, [myLeaveConfigList]);

    const holidayData = myLeaveConfigList?.map((member) => {
        return {
            value:member.qhlconfigid,
            label:member.year+"/"+member.name,
        };
    }); 

    const handleSelect = (id)=>{
        console.log("holidayData, id",holidayData,id)
        console.log("myLeaveConfigList",myLeaveConfigList)
        for(var i=0; i < holidayData?.length ; i++){
            if(holidayData[i].value == id){
               setID(i) 
               break; 
            }
        }
    }

    const holidayListNew = myLeaveConfigList?.[selecteID]?.holidaysarray?.map((item, idx) => {
            return {
                    id: idx + 1,
                    holidayname: item.holidayname,
                    location: item.location,
                    date: item.date,
            }})
    return (
        <div className="holidays-container">
          <div className="holidays-btns-wrapper">
            <Select
                style={{
                        width: 200,
                        height: 24,
                        textAlign: "left",
                        }}
                options={holidayData}
                defaultValue = {myLeaveConfigList?.[selecteID]?.year}
                onChange={handleSelect}
            />   
          </div>
            <h5> Holidays -- Year {myLeaveConfigList?.[selecteID]?.year + " - " + myLeaveConfigList?.[selecteID]?.name}</h5>
            { 
              
               holidayListNew != undefined  ? 
                    <HolidaysConfigTable
                                titleList={holidayTitles}
                                data={holidayListNew}
                                config ={`50px 2fr 1fr 2fr`}
                    />
                : 
                <Empty style={{ margin: "60px" }} />
            }            
        </div>
    );
}

export default Holidays;
